<template>
  <div class="with-sidebar">
    <div class="body">
      <form method="post" @submit.prevent="doSave">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label>FIRST NAME</label>
              <input type="text" name="first_name" id="first_name" ref="inputName"
                     :class="{'form-control': true, 'is-invalid': errors.has('first_name')}"
                     v-validate.disable="{ required: true }"
                     v-model="first_name">
              <div class="invalid-feedback">{{ errors.first('first_name') }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>LAST NAME</label>
              <input type="text" name="last_name" id="last_name"
                     :class="{'form-control': true, 'is-invalid': errors.has('last_name')}"
                     v-validate.disable="{ required: true }"
                     v-model="last_name">
              <div class="invalid-feedback">{{ errors.first('last_name') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label>EMAIL ADDRESS</label>
              <input type="text" name="email" id="email"
                     :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                     v-validate.disable="{ required: true }"
                     v-model="email">
              <div class="invalid-feedback">{{ errors.first('email') }}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>PHONE</label>
              <input type="text" name="phone" id="phone" class="form-control" v-model="phone">
            </div>
          </div>
        </div>
        <div class="config-for-staff-members" v-if="!IS_CLIENT">
          <hr />
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>HIDE TICKED TO-DO ITEMS AFTER</label>
                <select name="period_for_ticked_todo_items" id="period_for_ticked_todo_items" class="custom-select" v-model="period_for_ticked_todo_items">
                  <option v-for="opt in hideTodoItemsOptions" :key="opt" :value="opt">
                    {{ opt  }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-outline-black" :disabled="state == 'saving_profile'">
          {{ state == 'saving_profile' ? 'Please wait...' : 'Save changes' }}
        </button>
      </form>
    </div>
    <aside class="sidebar">
      <h4 class="wg-title">CHANGE PASSWORD</h4>
      <form method="post" @submit.prevent="doChangePassword">
        <div class="form-group">
          <label>NEW PASSWORD</label>
          <input type="password" class="form-control" v-model="password">
        </div>
        <div class="form-group">
          <label>RETYPE NEW PASSWORD</label>
          <input type="password" class="form-control" v-model="password_confirmation">
        </div>
        <button type="submit" class="btn btn-outline-black" :disabled="state == 'saving_password'">
          {{ state == 'saving_password' ? 'Please wait...' : 'Update Password' }}
        </button>
      </form>
    </aside>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import ServiceUser from '@/services/user'

  export default {
    data () {
      return {
        state: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        period_for_ticked_todo_items: '1 week',
        password: '',
        password_confirmation: ''
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['IS_CLIENT', 'CURRENT_USER']),
      ...mapState({
        hideTodoItemsOptions: state => state.option.hideTodoItemsOptions,
      })
    },
    mounted () {
      this.init();
    },
    methods: {
      init() {
        let self = this;
        if ( !self.CURRENT_USER ) return;

        self.first_name = self.CURRENT_USER.first_name;
        self.last_name = self.CURRENT_USER.last_name;
        self.email = self.CURRENT_USER.email;
        self.phone = self.CURRENT_USER.phone;
        self.period_for_ticked_todo_items = self.CURRENT_USER.period_for_ticked_todo_items;
      },
      doSave() {
        let self = this;
        if ( self.state != '' ) return;
        self.$validator.validateAll()
          .then(ok => {
            if ( ok ) {
              let postData = {
                first_name: self.first_name,
                last_name: self.last_name,
                email: self.email,
                phone: self.phone,
                period_for_ticked_todo_items: self.period_for_ticked_todo_items
              };
              self.state = 'saving_profile';
              ServiceUser.updateUserAccount(postData, user => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: 'Profile updated successfully'
                });
                self.$store.dispatch( 'SET_CURRENT_USER', user );
              }, () => {
                self.state = '';
              });
            }
          });
      },
      doChangePassword() {
        let self = this;
        if (!self.password) {
          self.$notify({
            type: 'error',
            text: 'Please enter the password'
          });
          return false;
        }
        if (self.password != self.password_confirmation) {
          self.$notify({
            type: 'error',
            text: 'Password and password confirmation does not match!'
          });
          return false;
        }
        let postData = {
          password: self.password,
          password_confirmation: self.password_confirmation
        };
        self.state = 'saving_password';
        ServiceUser.updateUserAccount(postData, function () {
          self.state = '';
          self.$notify({
            type: 'success',
            text: 'Password updated successfully'
          });
          self.password = '';
          self.password_confirmation = '';
        }, () => {
          self.state = '';
        });
      }
    }
  }
</script>
